import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const CodingPlayground = await import('./index');
    return {
        Component: CodingPlayground.default,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
